export const environment = {
    production: false,
    apiUrl: 'https://web.api.test.takenote.cloud',
    originatorId: 'reisebank-test-originator',
    firebaseConfig: {
        apiKey: "AIzaSyB3rl7lxabgq2OEz0dbiCj_bJKszpugIcA",
        authDomain: "cc-payavon-demo.firebaseapp.com",
        projectId: "cc-payavon-demo",
        storageBucket: "cc-payavon-demo.appspot.com",
        messagingSenderId: "598628678213",
        appId: "1:598628678213:web:d487016e41ac36564a012c",
        measurementId: "G-DB83251Q5T"
      },
    analyticsDebugMode: true
};